export default __webpack_public_path__ + "assets/image_maquette.930b2f8a.webp";